<section class="container">
    <div class="row">
        <div class="col-md-4 col-md-offset-4">
            <div *ngIf="errorMessage" class="alert alert-warning">{{ errorMessage }}</div>
            <form (submit)="onLogin()" #loginForm="ngForm" novalidate>
                <!-- tell the browser not to perform its default validation -->
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="text" class="form-control" name="email" [(ngModel)]="credentials.email" #email="ngModel" required /> <!-- this is an object that holds validation info that we can access -->
                    <div class="text-danger" *ngIf="email.touched && email.invalid && email.errors.required">Email is required!</div>
                </div>
                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" class="form-control" name="password" [(ngModel)]="credentials.password" #password="ngModel" required />
                    <div class="text-danger" *ngIf="password.touched && password.invalid && password.errors.required">Password is required!</div>
                </div>
                <div class="form-group">
                    <input type="submit" class="btn btn-success" value="Login" [disabled]="loginForm.invalid" />
                    <a routerLink="" class="btn btn-default">Cancel</a>
                </div>
            </form>
        </div>
    </div>
</section>